'use client';
import './global.css';
import '../lib/fontawesome';
import { TopBar } from 'components/appLayout/TopBar.tsx';
import { Footer } from 'components/appLayout/Footer.tsx';
import { Navigation } from 'components/appLayout/Navigation.tsx';
import VetopediaLogo from 'components/ui/VetopediaLogo.tsx';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18n';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import {
	RepositoryContext,
	generateRepository,
} from '../hooks/useRepositories.ts';

export const queryClient = new QueryClient();

const RootLayout = ({
	// Layouts must accept a children prop.
	// This will be populated with nested layouts or pages
	children,
}: Readonly<{
	children: React.ReactNode;
}>) => {
	return (
		<RepositoryContext.Provider value={generateRepository()}>
			<QueryClientProvider client={queryClient}>
				<I18nextProvider i18n={i18n} defaultNS={'translation'}>
					<html lang='en'>
						<body className='px-3'>
							<div className='outer-wrapper flex justify-center h-screen '>
								<div className='inner-wrapper w-full md:w-[1320px] flex flex-col'>
									<TopBar />
									<div className='w-full flex'>
										<div className='sidebar w-[290px] hidden md:flex flex-col overflow-y-scroll mr-3 '>
											<VetopediaLogo size={180} color='#3266CC' />
											<Navigation />
										</div>
										<div className='main flex w-full flex-col justify-between'>
											{children}
										</div>
									</div>
									<Footer />
								</div>
							</div>
						</body>
					</html>
				</I18nextProvider>
			</QueryClientProvider>
		</RepositoryContext.Provider>
	);
};

export default RootLayout;
